import React, { createElement } from "react";
import cx from "classnames";
import { Switch, Route } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core";

// core components
import AdminNavbar from "./AdminNavbar.js";
import Sidebar from "./Sidebar.js";

import routes from "./routes.js";

import styles from "./adminStyle.js";

import SaleObjTable from "../console/SaleObjTable";
import StatisticalResults from "../console/StatisticalResults";
import SaleObjDetailEdit from "../console/SaleObjDetailEdit.js";
import SaleObjDetail from "../console/SaleObjDetail.js";
import PropertyTablePrint from "../console/components/PropertyTablePrint.js";
import Map from "../console/components/Map.js";
var ps;

const useStyles = makeStyles(styles);

const consoleRoute = [
  { path: "/console/sale-obj-search-results", page: SaleObjTable },
  { path: "/console/statistical-results", page: StatisticalResults },
  { path: "/console/sale-obj-search-results/:id", page: SaleObjDetail },
  {
    path: "/console/sale-obj-search-results-edit/:id",
    page: SaleObjDetailEdit,
  },
  { path: "/console/property-table-print", page: PropertyTablePrint },
  { path: "/console/map", page: Map },
];

export default function Dashboard(props) {
  const identity = localStorage.getItem("@fullhouseIdentity");

  const newRoutes =
    Boolean(identity) &&
    routes.filter((item) => item.identities.includes(identity));

  const theme = useTheme();
  const useStyles2 = makeStyles((theme) => ({
    drawerPaper: {
      backgroundColor: theme.palette.primary.main,
    },
  }));
  const classes2 = useStyles2();
  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  const [color, setColor] = React.useState("blue");
  const [bgColor, setBgColor] = React.useState("black");
  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (newRoutes.length > 0) {
      if (navigator.platform.indexOf("Win") > -1) {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
        document.body.style.overflow = "hidden";
      }
      window.addEventListener("resize", resizeFunction);

      // Specify how to clean up after this effect:
      return function cleanup() {
        if (navigator.platform.indexOf("Win") > -1) {
          ps.destroy();
        }
        window.removeEventListener("resize", resizeFunction);
      };
    }
  }, [newRoutes]);
  // functions for changeing the states from components
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/console") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  if (newRoutes.length > 0) {
    return (
      <div className={classes.wrapper}>
        {getToken() && (
          <Sidebar
            routes={newRoutes}
            logoText={"管理後台"}
            logo={require("../images/logo192.png").default}
            handleDrawerToggle={handleDrawerToggle}
            handleCloseDrawer={() => setMobileOpen(false)}
            open={mobileOpen}
            color={color}
            bgColor={bgColor}
            miniActive={miniActive}
            {...rest}
          />
        )}
        <div className={mainPanelClasses} ref={mainPanel}>
          {getToken() && (
            <AdminNavbar
              sidebarMinimize={sidebarMinimize.bind(this)}
              miniActive={miniActive}
              brandText={getActiveRoute(newRoutes)}
              handleDrawerToggle={handleDrawerToggle}
              {...rest}
            />
          )}
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>
                <Switch>
                  {getRoutes(newRoutes)}
                  {consoleRoute.map((item) => (
                    <Route exact path={item.path} key={item.path}>
                      {createElement(item.page)}
                    </Route>
                  ))}
                </Switch>
              </div>
            </div>
          ) : (
            <div className={classes.map}>
              <Switch>
                {getRoutes(newRoutes)}
                {consoleRoute.map((item) => (
                  <Route exact path={item.path} key={item.path}>
                    {createElement(item.page)}
                  </Route>
                ))}
              </Switch>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function getToken() {
  return localStorage.getItem("@fullhouseToken");
}
